"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiMobileStepper = void 0;
var palette_1 = require("../../../theme/global/palette");
exports.MuiMobileStepper = {
    root: {
        position: 'relative',
        marginTop: 20,
        '& button:nth-child(1)': {
            position: 'absolute',
            left: 0,
        },
        '& button:nth-last-child(1)': {
            position: 'absolute',
            right: 0,
            '& :hover': {
                boxShadow: 'none',
            },
        },
        '& .Mui-disabled:nth-last-child(1)': {
            backgroundColor: palette_1.palette.grey[400],
        },
    },
    dots: {
        width: '100%',
        justifyContent: 'center',
    },
};
